module.exports = __webpack_public_path__ + "static/media/56.7bd859e4.jpg";